import { CheckIcon, MinusIcon } from 'lucide-react'
import { Checkbox as CheckboxPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/lib/utils'

/**
 * Quadrado de 20px com borda de 2px — a geometria do `Checkbox` do MUI, que
 * desenha um retângulo de 18px com traço grosso. Marcado, vira bloco `primary`
 * com o ícone em branco; indeterminado mostra o traço, como o MUI.
 */
function Checkbox({
    className,
    ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
    return (
        <CheckboxPrimitive.Root
            data-slot="checkbox"
            className={cn(
                'peer size-5 shrink-0 rounded-sm',
                'border-2 border-foreground/60 bg-transparent',
                'hover:border-foreground',
                'transition-[color,background-color,border-color,box-shadow] outline-none',
                'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
                'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
                'dark:aria-invalid:ring-destructive/40',
                'data-[state=checked]:border-primary data-[state=checked]:bg-primary',
                'data-[state=checked]:text-primary-foreground',
                'data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary',
                'data-[state=indeterminate]:text-primary-foreground',
                'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-disabled',
                className,
            )}
            {...props}
        >
            <CheckboxPrimitive.Indicator
                data-slot="checkbox-indicator"
                className="flex items-center justify-center text-current transition-none"
            >
                {props.checked === 'indeterminate' ? (
                    <MinusIcon className="size-4" strokeWidth={3} />
                ) : (
                    <CheckIcon className="size-4" strokeWidth={3} />
                )}
            </CheckboxPrimitive.Indicator>
        </CheckboxPrimitive.Root>
    )
}

export { Checkbox }
